(function () {
  'use strict';

  var selector = '#province-select, #province-select-mobile, #district-select, .pickup-desktop-province-select';
  var instances = [];

  function normalizeSearchValue(value) {
    return String(value || '')
      .toLocaleLowerCase('tr-TR')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ı/g, 'i')
      .normalize('NFC')
      .trim();
  }

  function sortLocationLabels(labels) {
    return Array.from(labels || []).sort(function (first, second) {
      var firstLabel = first && typeof first === 'object' ? first.textContent : first;
      var secondLabel = second && typeof second === 'object' ? second.textContent : second;

      return String(firstLabel || '').localeCompare(String(secondLabel || ''), 'tr', { sensitivity: 'base' });
    });
  }

  function close(instance) {
    instance.isOpen = false;
    instance.searchWrap.hidden = true;
    instance.options.hidden = true;
    instance.trigger.setAttribute('aria-expanded', 'false');
    instance.search.setAttribute('aria-expanded', 'false');
    instance.search.value = '';
    instance.query = '';
    instance.activeIndex = -1;
    instance.search.removeAttribute('aria-activedescendant');
  }

  function closeOthers(current) {
    instances.forEach(function (instance) {
      if (instance !== current) close(instance);
    });
  }

  function getSelectableOptions(select) {
    return Array.prototype.filter.call(select.options || [], function (option) {
      return option.value && !option.disabled && !option.hidden;
    });
  }

  function getOptionButtons(instance) {
    return Array.prototype.slice.call(instance.options.querySelectorAll('[role="option"]'))
      .filter(function (option) {
        return option.dataset && option.dataset.value;
      });
  }

  function setActiveOption(instance, nextIndex) {
    var optionButtons = getOptionButtons(instance);

    if (!optionButtons.length) {
      instance.activeIndex = -1;
      instance.search.removeAttribute('aria-activedescendant');
      return;
    }

    var normalizedIndex = (nextIndex + optionButtons.length) % optionButtons.length;
    instance.activeIndex = normalizedIndex;
    optionButtons.forEach(function (option, index) {
      var isActive = index === normalizedIndex;
      option.classList.toggle('is-active', isActive);
      option.setAttribute('aria-selected', option.dataset.value === instance.select.value ? 'true' : 'false');
    });

    var activeOption = optionButtons[normalizedIndex];
    if (activeOption) {
      instance.search.setAttribute('aria-activedescendant', activeOption.id);
      activeOption.scrollIntoView({ block: 'nearest' });
    }
  }

  function selectOption(instance, option) {
    if (!option || !option.dataset.value) {
      return;
    }

    instance.select.value = option.dataset.value;
    instance.select.dispatchEvent(new Event('change', { bubbles: true }));
    close(instance);
    sync(instance);
    instance.trigger.focus();
  }

  function render(instance) {
    var query = normalizeSearchValue(instance.query);
    var selectableOptions = sortLocationLabels(getSelectableOptions(instance.select).map(function (option) {
      return option;
    }));
    var filteredOptions = selectableOptions.filter(function (option) {
      return !query || normalizeSearchValue(option.textContent).includes(query);
    });

    instance.options.innerHTML = '';

    if (!filteredOptions.length) {
      var status = document.createElement('span');
      status.className = 'montaj-district-status montaj-location-status';
      status.setAttribute('role', 'status');
      status.textContent = instance.select.disabled ? 'Seçenekler yükleniyor...' : 'Uygun seçenek bulunamadı.';
      instance.options.appendChild(status);
      instance.activeIndex = -1;
      instance.search.removeAttribute('aria-activedescendant');
      return;
    }

    filteredOptions.forEach(function (option, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.id = instance.listboxId + '-option-' + index;
      button.className = 'montaj-district-option montaj-location-option';
      button.setAttribute('role', 'option');
      button.setAttribute('aria-selected', option.value === instance.select.value ? 'true' : 'false');
      button.dataset.value = option.value;
      button.textContent = option.textContent;
      button.addEventListener('click', function () {
        selectOption(instance, button);
      });
      instance.options.appendChild(button);
    });

    var selectedIndex = filteredOptions.findIndex(function (option) {
      return option.value === instance.select.value;
    });
    setActiveOption(instance, selectedIndex >= 0 ? selectedIndex : 0);
  }

  function sync(instance) {
    var select = instance.select;
    var selectedOption = select.options[select.selectedIndex];
    var placeholder = select.options[0];

    instance.label.textContent = selectedOption && selectedOption.value
      ? selectedOption.textContent
      : (placeholder ? placeholder.textContent : 'Seçiniz');
    instance.trigger.disabled = select.disabled;
    instance.trigger.setAttribute('aria-busy', select.getAttribute('aria-busy') || 'false');
    instance.trigger.classList.toggle('is-loading', select.classList.contains('is-loading'));
    instance.search.disabled = select.disabled;

    if (select.disabled) {
      close(instance);
    }

    if (instance.isOpen) {
      render(instance);
    }
  }

  function filterServiceDistrictOptions(control, query) {
    var options = control.querySelector('[data-district-options]');
    var normalizedQuery = normalizeSearchValue(query);
    var visibleCount = 0;

    if (!options) return;

    Array.prototype.forEach.call(options.querySelectorAll('[data-district-value]'), function (option) {
      var isVisible = !normalizedQuery || normalizeSearchValue(option.dataset.districtValue).includes(normalizedQuery);
      option.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    var emptyState = options.querySelector('[data-district-search-empty]');
    if (emptyState) emptyState.remove();

    if (normalizedQuery && visibleCount === 0) {
      emptyState = document.createElement('div');
      emptyState.className = 'montaj-district-status';
      emptyState.dataset.districtSearchEmpty = 'true';
      emptyState.setAttribute('role', 'status');
      emptyState.textContent = 'Sonuç bulunamadı.';
      options.appendChild(emptyState);
    }
  }

  function initServiceDistrictSearch() {
    document.querySelectorAll('[data-service-controls]').forEach(function (control) {
      if (control.dataset.districtSearchBound === 'true') return;
      control.dataset.districtSearchBound = 'true';

      var trigger = control.querySelector('[data-district-trigger]');
      var options = control.querySelector('[data-district-options]');
      var searchWrap = control.querySelector('[data-district-search-wrap]');
      var search = control.querySelector('[data-district-search]');

      if (!trigger || !options || !search) return;

      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-controls', options.id);
      search.classList.add('montaj-location-search');
      search.autocomplete = 'off';
      search.placeholder = 'İlçe ara';
      search.setAttribute('aria-label', 'İlçe ara');
      search.setAttribute('role', 'combobox');
      search.setAttribute('aria-autocomplete', 'list');
      search.setAttribute('aria-expanded', 'false');
      search.setAttribute('aria-controls', options.id);

      trigger.addEventListener('click', function () {
        var willOpen = options.hidden;

        document.querySelectorAll('[data-service-controls]').forEach(function (otherControl) {
          var otherOptions = otherControl.querySelector('[data-district-options]');
          var otherTrigger = otherControl.querySelector('[data-district-trigger]');
          var otherSearchWrap = otherControl.querySelector('[data-district-search-wrap]');
          var otherSearch = otherControl.querySelector('[data-district-search]');

          if (otherOptions) otherOptions.hidden = true;
          if (otherSearchWrap) otherSearchWrap.hidden = true;
          if (otherSearch) {
            otherSearch.value = '';
            otherSearch.setAttribute('aria-expanded', 'false');
          }
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        });

        options.hidden = !willOpen;
        searchWrap.hidden = !willOpen;
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        search.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        if (willOpen) {
          filterServiceDistrictOptions(control, '');
          search.focus();
        }
      });

      search.addEventListener('input', function () {
        filterServiceDistrictOptions(control, search.value);
      });

      search.addEventListener('keydown', function (event) {
        var visibleOptions = Array.prototype.filter.call(
          options.querySelectorAll('[data-district-value]'),
          function (option) { return !option.hidden; }
        );

        if (event.key === 'Escape') {
          event.preventDefault();
          options.hidden = true;
          searchWrap.hidden = true;
          search.setAttribute('aria-expanded', 'false');
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        } else if (event.key === 'ArrowDown' && visibleOptions.length) {
          event.preventDefault();
          visibleOptions[0].focus();
        }
      });

      options.addEventListener('keydown', function (event) {
        var visibleOptions = Array.prototype.filter.call(
          options.querySelectorAll('[data-district-value]'),
          function (option) { return !option.hidden; }
        );
        var activeIndex = visibleOptions.indexOf(document.activeElement);

        if (event.key === 'Escape') {
          event.preventDefault();
          options.hidden = true;
          searchWrap.hidden = true;
          search.setAttribute('aria-expanded', 'false');
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        } else if (event.key === 'ArrowDown' && visibleOptions.length) {
          event.preventDefault();
          visibleOptions[(activeIndex + 1) % visibleOptions.length].focus();
        } else if (event.key === 'ArrowUp' && visibleOptions.length) {
          event.preventDefault();
          visibleOptions[(activeIndex - 1 + visibleOptions.length) % visibleOptions.length].focus();
        } else if (event.key === 'Enter' && document.activeElement?.dataset?.districtValue) {
          event.preventDefault();
          document.activeElement.click();
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-service-controls]')) return;

      document.querySelectorAll('[data-service-controls]').forEach(function (control) {
        var options = control.querySelector('[data-district-options]');
        var trigger = control.querySelector('[data-district-trigger]');
        var searchWrap = control.querySelector('[data-district-search-wrap]');
        var search = control.querySelector('[data-district-search]');

        if (options) options.hidden = true;
        if (searchWrap) searchWrap.hidden = true;
        if (search) {
          search.value = '';
          search.setAttribute('aria-expanded', 'false');
        }
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function open(instance) {
    if (instance.trigger.disabled) {
      return;
    }

    closeOthers(instance);
    instance.isOpen = true;
    instance.searchWrap.hidden = false;
    instance.options.hidden = false;
    instance.trigger.setAttribute('aria-expanded', 'true');
    instance.search.setAttribute('aria-expanded', 'true');
    instance.query = '';
    instance.search.value = '';
    render(instance);
    instance.search.focus();
  }

  function enhance(select) {
    if (!select || select.dataset.locationSelectBound === 'true') return;
    select.dataset.locationSelectBound = 'true';

    var wrapper = document.createElement('div');
    var trigger = document.createElement('button');
    var label = document.createElement('span');
    var searchWrap = document.createElement('div');
    var search = document.createElement('input');
    var options = document.createElement('div');
    var listboxId = (select.id || 'montaj-location') + '-options';
    var searchText = select.id === 'district-select' ? 'İlçe ara' : 'İl ara';

    wrapper.className = 'montaj-district-combobox montaj-location-combobox';
    trigger.type = 'button';
    trigger.className = 'montaj-district-trigger montaj-location-trigger';
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', listboxId);
    trigger.setAttribute('aria-haspopup', 'listbox');
    label.className = 'montaj-location-label';

    searchWrap.className = 'montaj-location-search-wrap';
    searchWrap.hidden = true;
    search.type = 'search';
    search.className = 'montaj-location-search';
    search.autocomplete = 'off';
    search.placeholder = searchText;
    search.setAttribute('role', 'combobox');
    search.setAttribute('aria-autocomplete', 'list');
    search.setAttribute('aria-expanded', 'false');
    search.setAttribute('aria-controls', listboxId);
    search.setAttribute('aria-label', searchText);

    options.id = listboxId;
    options.className = 'montaj-district-options montaj-location-options';
    options.setAttribute('role', 'listbox');
    options.hidden = true;
    trigger.appendChild(label);
    searchWrap.appendChild(search);
    searchWrap.appendChild(options);

    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(select);
    wrapper.appendChild(trigger);
    wrapper.appendChild(searchWrap);
    select.classList.add('montaj-location-native-select');

    var instance = {
      activeIndex: -1,
      isOpen: false,
      label: label,
      listboxId: listboxId,
      options: options,
      query: '',
      search: search,
      searchWrap: searchWrap,
      select: select,
      trigger: trigger,
      wrapper: wrapper
    };
    instances.push(instance);
    sync(instance);

    trigger.addEventListener('click', function () {
      if (instance.isOpen) {
        close(instance);
        return;
      }

      open(instance);
    });
    trigger.addEventListener('keydown', function (event) {
      if (['ArrowDown', 'Enter', ' '].includes(event.key)) {
        event.preventDefault();
        open(instance);
      }
    });
    search.addEventListener('input', function () {
      instance.query = search.value;
      render(instance);
    });
    search.addEventListener('keydown', function (event) {
      var optionButtons = getOptionButtons(instance);

      if (event.key === 'Escape') {
        event.preventDefault();
        close(instance);
        trigger.focus();
      } else if (event.key === 'ArrowDown' && optionButtons.length) {
        event.preventDefault();
        setActiveOption(instance, instance.activeIndex + 1);
      } else if (event.key === 'ArrowUp' && optionButtons.length) {
        event.preventDefault();
        setActiveOption(instance, instance.activeIndex - 1);
      } else if (event.key === 'Enter' && optionButtons.length) {
        event.preventDefault();
        selectOption(instance, optionButtons[instance.activeIndex] || optionButtons[0]);
      }
    });
    options.addEventListener('keydown', function (event) {
      var items = getOptionButtons(instance);
      var index = items.indexOf(document.activeElement);

      if (event.key === 'Escape') {
        close(instance);
        trigger.focus();
      } else if (event.key === 'ArrowDown' && items.length) {
        event.preventDefault();
        items[(index + 1) % items.length].focus();
      } else if (event.key === 'ArrowUp' && items.length) {
        event.preventDefault();
        items[(index - 1 + items.length) % items.length].focus();
      }
    });
    select.addEventListener('change', function () {
      sync(instance);
    });
    select.addEventListener('focus', function () {
      trigger.focus();
    });

    new MutationObserver(function () {
      sync(instance);
    }).observe(select, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-busy', 'class'],
      childList: true,
      subtree: true
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches(selector)) enhance(scope);
    scope.querySelectorAll(selector).forEach(enhance);
  }

  function start() {
    init(document);
    initServiceDistrictSearch();
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) init(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (event) {
    instances.forEach(function (instance) {
      if (!instance.wrapper.contains(event.target)) close(instance);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
